import { isNonNullable } from '@ori/ts-utils';
import { useMemo } from 'react';
import { useAutoplay } from './useAutoplay';
import { useKeyboard } from './useKeyboard';
export const usePlugins = (props, setIsTouchActive) => {
  const autoplay = useAutoplay(props, setIsTouchActive);
  const keyboard = useKeyboard(props);
  return useMemo(() => [autoplay, keyboard].filter(isNonNullable), [autoplay, keyboard]);
};
//# sourceMappingURL=usePlugins.js.map